import { createRouter, createWebHistory } from 'vue-router';
import { loadingState } from './loading.js';
import Dashboard from './pages/Dashboard.vue';
import CertsPage from './pages/CertsPage.vue';
import CertCreate from './pages/CertCreate.vue';
import CertDetail from './pages/CertDetail.vue';
import CertVerification from './pages/CertVerification.vue';
import CertPdfDetail from './pages/CertPdfDetail.vue';
import ClientProfile from './pages/ClientProfile.vue';
import FileDetail from './pages/FileDetail.vue';
import FilesPage from './pages/FilesPage.vue';
import CreditsPage from "./pages/CreditsPage.vue";
import FileSharingView from "./pages/FileSharingView.vue";
import NotFound from "./pages/NotFound.vue";

const routes = [
    {
        // AppLayout je jednoduchý passthrough — transition a PageLoader sú len v root App.vue
        path: '/',
        component: () => import('./AppLayout.vue'),
        //redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: Dashboard,
                meta: {
                    auth: true
                }
            },
            {
                path: '/certs/create',
                name: 'CertCreate',
                component: CertCreate,
                meta: { auth: true }
            },
            {
                path: '/certs',
                name: 'CertList',
                component: CertsPage,
                meta: {
                    auth: true
                }
            },
            {
                path: '/certs/:uuid/detail',
                name: 'CertDetail',
                component: CertDetail,
                meta: {
                    auth: true
                }
            },
            {
                path: '/certs/:uuid/view',
                name: 'CertPdfDetail',
                component: CertPdfDetail,
                meta: {
                    auth: true
                }
            },
            {
                path: '/files/:uuid/detail',
                name: 'FileDetail',
                component: FileDetail,
                meta: {
                    auth: true
                }
            },
            {
                path: '/profile',
                name: 'ClientProfile',
                component: ClientProfile,
                meta: {
                    auth: true
                }
            },
            {
                path: '/files',
                name: 'FilesPage',
                component: FilesPage,
                meta: { auth: true }
            },
            {
                path: '/my-credits',
                name: 'CreditsPage',
                component: CreditsPage,
                meta: {
                    auth: true
                }
            },
            {
                path: '/:pathMatch(.*)*',
                name: 'NotFound',
                component: NotFound,
                meta: { auth: true }
            },
        ]
    },
    {
        // Veřejná route — uživatel nemusí být přihlášen, vlastní nav header
        path: '/verification/:hash?',
        name: 'CertVerification',
        component: CertVerification,
    },
    {
        path: '/file-shares/:uuid',
        component: FileSharingView
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    },
})
router.beforeEach(() => { loadingState.active = true; });
router.afterEach(() => { loadingState.active = false; });


export default router
